import { API_BASE_URL } from './api.config';

// Temporary sandbox order until checkout creates real orders through the backend.
// The backend must return this same order and amount; never put API secrets here.
export const IZIPAY_SANDBOX_ORDER = { orderId: '3', amount: 189.90 } as const;
export const IZIPAY_SDK_URL = 'https://sandbox-checkout.izipay.pe/payments/v1/js/index.js';

// El dominio cambia mediante los fileReplacements de Angular según el ambiente.
export const IZIPAY_IPN_URL = `${API_BASE_URL}/izipay/ipn`;

// Izipay exige ambos objetos. Estos datos se usan solo cuando el flujo todavía no dispone
// de información del comprador o de una dirección de envío real.
export const IZIPAY_SANDBOX_BUYER = {
  firstName: 'Lucho',
  lastName: 'Torres',
  email: 'luchotorres@izipay.pe',
  phoneNumber: '989897960',
  street: 'Av. Jorge Chávez 275',
  city: 'Lima',
  state: 'Lima',
  country: 'PE',
  postalCode: '15000',
  documentType: 'DNI',
  document: '12345678',
} as const;
